import type { ReactNode } from "react";
import { css } from "styled-system/css";

interface HeadBannerProps {
  lifetimeSlot: ReactNode;
  readyToClaimSlot: ReactNode;
  ytdSlot: ReactNode;
  weeklyTrendSlot: ReactNode;
}

export function HeadBanner({
  lifetimeSlot,
  readyToClaimSlot,
  ytdSlot,
  weeklyTrendSlot,
}: HeadBannerProps) {
  return (
    <div className={containerStyles}>
      <Cell>{lifetimeSlot}</Cell>
      <Cell>{readyToClaimSlot}</Cell>
      <Cell>{ytdSlot}</Cell>
      <Cell>{weeklyTrendSlot}</Cell>
    </div>
  );
}

function Cell({ children }: { children: ReactNode }) {
  return <div className={cellStyles}>{children}</div>;
}

const containerStyles = css({
  display: "grid",
  w: "full",
  rounded: "300",
  borderWidth: "100",
  borderStyle: "solid",
  borderColor: "border.primary",
  bgGradient: "rewardsBanner",
  overflow: "hidden",
  gridTemplateColumns: "minmax(0, 1fr)",
  "@media (min-width: 768px)": {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  "@media (min-width: 1080px)": {
    gridTemplateColumns: "518fr 374fr 374fr 413fr",
  },
});

const cellStyles = css({
  rounded: "200",
  borderColor: "border.primary",
  borderStyle: "solid",
  borderRightWidth: "[0]",
  borderBottomWidth: "[0]",
  "@media (max-width: 767.98px)": {
    "&:not(:last-child)": { borderBottomWidth: "100" },
  },
  "@media (min-width: 768px) and (max-width: 1079.98px)": {
    "&:nth-child(odd)": { borderRightWidth: "100" },
    "&:nth-child(-n+2)": { borderBottomWidth: "100" },
  },
  "@media (min-width: 1080px)": {
    "&:not(:last-child)": { borderRightWidth: "100" },
  },
});
